// src/api/orders.js
import axios from 'axios';

// Point this at your own proxy or absolute URL if needed
//const API = axios.create({ baseURL: 'http://localhost:5000/api' });
const API = axios.create({ baseURL: 'https://kiosk-api.sortswift.com/api', timeout: 300000 });

/**
 * Create a new order for the given store.
 * @param {string} storeName
 * @param {{
 *   customerName: string,
 *   items: Array<{
 *     skuId: number,
 *     quantity: number,
 *     price: number,
 *     cleanName: string,
 *     condAbbr?: string,
 *     printing?: string
 *   }>
 * }} payload
 */
export const createOrder = (storeName, payload) =>
  API.post(`/orders/${storeName}`, payload);
